// source: subscription.proto

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();

var enum_pb = require('./enum_pb.js');

goog.object.extend(proto, enum_pb);

var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');

goog.object.extend(proto, google_protobuf_struct_pb);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');

goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.manabie.bob.CheckPromotionCodeRequest', null, global);
goog.exportSymbol('proto.manabie.bob.CheckPromotionCodeResponse', null, global);
goog.exportSymbol('proto.manabie.bob.CodOrderInfo', null, global);
goog.exportSymbol('proto.manabie.bob.CreateGHNOrderRequest', null, global);
goog.exportSymbol('proto.manabie.bob.CreateGHNOrderResponse', null, global);
goog.exportSymbol('proto.manabie.bob.CreateManualOrderRequest', null, global);
goog.exportSymbol('proto.manabie.bob.CreateManualOrderResponse', null, global);
goog.exportSymbol('proto.manabie.bob.CreateOnlineOrderRequest', null, global);
goog.exportSymbol('proto.manabie.bob.CreateOnlineOrderResponse', null, global);
goog.exportSymbol('proto.manabie.bob.CreatePromotionRequest', null, global);
goog.exportSymbol('proto.manabie.bob.CreatePromotionResponse', null, global);
goog.exportSymbol('proto.manabie.bob.DisableOrderRequest', null, global);
goog.exportSymbol('proto.manabie.bob.DisableOrderResponse', null, global);
goog.exportSymbol('proto.manabie.bob.ListOrdersRequest', null, global);
goog.exportSymbol('proto.manabie.bob.ListOrdersResponse', null, global);
goog.exportSymbol('proto.manabie.bob.MarkOrderProcessingRequest', null, global);
goog.exportSymbol('proto.manabie.bob.MarkOrderProcessingResponse', null, global);
goog.exportSymbol('proto.manabie.bob.Order', null, global);
goog.exportSymbol('proto.manabie.bob.Package', null, global);
goog.exportSymbol('proto.manabie.bob.PackageItem', null, global);
goog.exportSymbol('proto.manabie.bob.Plan', null, global);
goog.exportSymbol('proto.manabie.bob.PromoDiscountType', null, global);
goog.exportSymbol('proto.manabie.bob.PromoStatus', null, global);
goog.exportSymbol('proto.manabie.bob.PromoType', null, global);
goog.exportSymbol('proto.manabie.bob.Promotion', null, global);
goog.exportSymbol('proto.manabie.bob.PromotionRule', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveCurrentSubscriptionRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveCurrentSubscriptionResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrievePackagesRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrievePackagesResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrievePlansRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrievePlansResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrievePromotionCodePrefixesRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrievePromotionCodePrefixesResponse', null, global);
goog.exportSymbol('proto.manabie.bob.StudentSubscription', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateAsiaPayOrderRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateAsiaPayOrderResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateGHNOrderRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateGHNOrderResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UpdatePaymentMethodRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpdatePaymentMethodResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UpdatePromotionRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpdatePromotionResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UsePromotionCodeRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UsePromotionCodeResponse', null, global);
goog.exportSymbol('proto.manabie.bob.VerifyIosReceiptRequest', null, global);
goog.exportSymbol('proto.manabie.bob.VerifyIosReceiptResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */

proto.manabie.bob.Plan = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.Plan.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.Plan, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.Plan.displayName = 'proto.manabie.bob.Plan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrievePlansRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrievePlansRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrievePlansRequest.displayName = 'proto.manabie.bob.RetrievePlansRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrievePlansResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrievePlansResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrievePlansResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrievePlansResponse.displayName = 'proto.manabie.bob.RetrievePlansResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.Package = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.Package.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.Package, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.Package.displayName = 'proto.manabie.bob.Package';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.PackageItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.PackageItem.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.PackageItem, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.PackageItem.displayName = 'proto.manabie.bob.PackageItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrievePackagesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrievePackagesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrievePackagesRequest.displayName = 'proto.manabie.bob.RetrievePackagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrievePackagesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrievePackagesResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrievePackagesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrievePackagesResponse.displayName = 'proto.manabie.bob.RetrievePackagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CreateOnlineOrderRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CreateOnlineOrderRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CreateOnlineOrderRequest.displayName = 'proto.manabie.bob.CreateOnlineOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CreateOnlineOrderResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CreateOnlineOrderResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CreateOnlineOrderResponse.displayName = 'proto.manabie.bob.CreateOnlineOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CodOrderInfo = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CodOrderInfo, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CodOrderInfo.displayName = 'proto.manabie.bob.CodOrderInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.StudentSubscription = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.StudentSubscription.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.StudentSubscription, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.StudentSubscription.displayName = 'proto.manabie.bob.StudentSubscription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.Order = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.Order.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.Order, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.Order.displayName = 'proto.manabie.bob.Order';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.ListOrdersRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.ListOrdersRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.ListOrdersRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ListOrdersRequest.displayName = 'proto.manabie.bob.ListOrdersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.ListOrdersResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.ListOrdersResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.ListOrdersResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ListOrdersResponse.displayName = 'proto.manabie.bob.ListOrdersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdateAsiaPayOrderRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateAsiaPayOrderRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateAsiaPayOrderRequest.displayName = 'proto.manabie.bob.UpdateAsiaPayOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdateAsiaPayOrderResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateAsiaPayOrderResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateAsiaPayOrderResponse.displayName = 'proto.manabie.bob.UpdateAsiaPayOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CreateManualOrderRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CreateManualOrderRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CreateManualOrderRequest.displayName = 'proto.manabie.bob.CreateManualOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CreateManualOrderResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CreateManualOrderResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CreateManualOrderResponse.displayName = 'proto.manabie.bob.CreateManualOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.DisableOrderRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.DisableOrderRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.DisableOrderRequest.displayName = 'proto.manabie.bob.DisableOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.DisableOrderResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.DisableOrderResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.DisableOrderResponse.displayName = 'proto.manabie.bob.DisableOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrievePromotionCodePrefixesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrievePromotionCodePrefixesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrievePromotionCodePrefixesRequest.displayName = 'proto.manabie.bob.RetrievePromotionCodePrefixesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrievePromotionCodePrefixesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrievePromotionCodePrefixesResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrievePromotionCodePrefixesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrievePromotionCodePrefixesResponse.displayName = 'proto.manabie.bob.RetrievePromotionCodePrefixesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.Promotion = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.Promotion.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.Promotion, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.Promotion.displayName = 'proto.manabie.bob.Promotion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.PromotionRule = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.PromotionRule, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.PromotionRule.displayName = 'proto.manabie.bob.PromotionRule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CreatePromotionRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CreatePromotionRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CreatePromotionRequest.displayName = 'proto.manabie.bob.CreatePromotionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CreatePromotionResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CreatePromotionResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CreatePromotionResponse.displayName = 'proto.manabie.bob.CreatePromotionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdatePromotionRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdatePromotionRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdatePromotionRequest.displayName = 'proto.manabie.bob.UpdatePromotionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdatePromotionResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdatePromotionResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdatePromotionResponse.displayName = 'proto.manabie.bob.UpdatePromotionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UsePromotionCodeRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UsePromotionCodeRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UsePromotionCodeRequest.displayName = 'proto.manabie.bob.UsePromotionCodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UsePromotionCodeResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UsePromotionCodeResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UsePromotionCodeResponse.displayName = 'proto.manabie.bob.UsePromotionCodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CheckPromotionCodeRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CheckPromotionCodeRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CheckPromotionCodeRequest.displayName = 'proto.manabie.bob.CheckPromotionCodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CheckPromotionCodeResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CheckPromotionCodeResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CheckPromotionCodeResponse.displayName = 'proto.manabie.bob.CheckPromotionCodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CreateGHNOrderRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CreateGHNOrderRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CreateGHNOrderRequest.displayName = 'proto.manabie.bob.CreateGHNOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CreateGHNOrderResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CreateGHNOrderResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CreateGHNOrderResponse.displayName = 'proto.manabie.bob.CreateGHNOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdateGHNOrderRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateGHNOrderRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateGHNOrderRequest.displayName = 'proto.manabie.bob.UpdateGHNOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdateGHNOrderResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateGHNOrderResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateGHNOrderResponse.displayName = 'proto.manabie.bob.UpdateGHNOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdatePaymentMethodRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdatePaymentMethodRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdatePaymentMethodRequest.displayName = 'proto.manabie.bob.UpdatePaymentMethodRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdatePaymentMethodResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdatePaymentMethodResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdatePaymentMethodResponse.displayName = 'proto.manabie.bob.UpdatePaymentMethodResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveCurrentSubscriptionRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveCurrentSubscriptionRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveCurrentSubscriptionRequest.displayName = 'proto.manabie.bob.RetrieveCurrentSubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveCurrentSubscriptionResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveCurrentSubscriptionResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveCurrentSubscriptionResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveCurrentSubscriptionResponse.displayName = 'proto.manabie.bob.RetrieveCurrentSubscriptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.MarkOrderProcessingRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.MarkOrderProcessingRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.MarkOrderProcessingRequest.displayName = 'proto.manabie.bob.MarkOrderProcessingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.MarkOrderProcessingResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.MarkOrderProcessingResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.MarkOrderProcessingResponse.displayName = 'proto.manabie.bob.MarkOrderProcessingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.VerifyIosReceiptRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.VerifyIosReceiptRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.VerifyIosReceiptRequest.displayName = 'proto.manabie.bob.VerifyIosReceiptRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.VerifyIosReceiptResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.VerifyIosReceiptResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.VerifyIosReceiptResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.VerifyIosReceiptResponse.displayName = 'proto.manabie.bob.VerifyIosReceiptResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest.displayName = 'proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.displayName = 'proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.Plan.repeatedFields_ = [5, 6];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.Plan.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.Plan.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.Plan} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.Plan.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      description: jspb.Message.getFieldWithDefault(msg, 2, ""),
      advertisedPrice: jspb.Message.getFieldWithDefault(msg, 3, ""),
      isPurchasable: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
      upgradeableToList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
      benefitsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
      prioritizeLevel: jspb.Message.getFieldWithDefault(msg, 7, 0),
      isHidden: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.Plan}
 */


proto.manabie.bob.Plan.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.Plan();
  return proto.manabie.bob.Plan.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.Plan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.Plan}
 */


proto.manabie.bob.Plan.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDescription(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAdvertisedPrice(value);
        break;

      case 4:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsPurchasable(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addUpgradeableTo(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addBenefits(value);
        break;

      case 7:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPrioritizeLevel(value);
        break;

      case 8:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsHidden(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.Plan.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.Plan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.Plan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.Plan.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getDescription();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getAdvertisedPrice();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getIsPurchasable();

  if (f) {
    writer.writeBool(4, f);
  }

  f = message.getUpgradeableToList();

  if (f.length > 0) {
    writer.writeRepeatedString(5, f);
  }

  f = message.getBenefitsList();

  if (f.length > 0) {
    writer.writeRepeatedString(6, f);
  }

  f = message.getPrioritizeLevel();

  if (f !== 0) {
    writer.writeInt32(7, f);
  }

  f = message.getIsHidden();

  if (f) {
    writer.writeBool(8, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.Plan.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Plan.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string description = 2;
 * @return {string}
 */


proto.manabie.bob.Plan.prototype.getDescription = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Plan.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string advertised_price = 3;
 * @return {string}
 */


proto.manabie.bob.Plan.prototype.getAdvertisedPrice = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Plan.prototype.setAdvertisedPrice = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional bool is_purchasable = 4;
 * @return {boolean}
 */


proto.manabie.bob.Plan.prototype.getIsPurchasable = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 4, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.Plan.prototype.setIsPurchasable = function (value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};
/**
 * repeated string upgradeable_to = 5;
 * @return {!Array<string>}
 */


proto.manabie.bob.Plan.prototype.getUpgradeableToList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 5)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.Plan.prototype.setUpgradeableToList = function (value) {
  jspb.Message.setField(this, 5, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.Plan.prototype.addUpgradeableTo = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Plan.prototype.clearUpgradeableToList = function () {
  this.setUpgradeableToList([]);
};
/**
 * repeated string benefits = 6;
 * @return {!Array<string>}
 */


proto.manabie.bob.Plan.prototype.getBenefitsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 6)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.Plan.prototype.setBenefitsList = function (value) {
  jspb.Message.setField(this, 6, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.Plan.prototype.addBenefits = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Plan.prototype.clearBenefitsList = function () {
  this.setBenefitsList([]);
};
/**
 * optional int32 prioritize_level = 7;
 * @return {number}
 */


proto.manabie.bob.Plan.prototype.getPrioritizeLevel = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Plan.prototype.setPrioritizeLevel = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * optional bool is_hidden = 8;
 * @return {boolean}
 */


proto.manabie.bob.Plan.prototype.getIsHidden = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 8, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.Plan.prototype.setIsHidden = function (value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrievePlansRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrievePlansRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrievePlansRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrievePlansRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      country: jspb.Message.getFieldWithDefault(msg, 1, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrievePlansRequest}
 */


proto.manabie.bob.RetrievePlansRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrievePlansRequest();
  return proto.manabie.bob.RetrievePlansRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrievePlansRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrievePlansRequest}
 */


proto.manabie.bob.RetrievePlansRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrievePlansRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrievePlansRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrievePlansRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrievePlansRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }
};
/**
 * optional Country country = 1;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.RetrievePlansRequest.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.RetrievePlansRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrievePlansResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrievePlansResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrievePlansResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrievePlansResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrievePlansResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      plansList: jspb.Message.toObjectList(msg.getPlansList(), proto.manabie.bob.Plan.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrievePlansResponse}
 */


proto.manabie.bob.RetrievePlansResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrievePlansResponse();
  return proto.manabie.bob.RetrievePlansResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrievePlansResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrievePlansResponse}
 */


proto.manabie.bob.RetrievePlansResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Plan();
        reader.readMessage(value, proto.manabie.bob.Plan.deserializeBinaryFromReader);
        msg.addPlans(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrievePlansResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrievePlansResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrievePlansResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrievePlansResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPlansList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.Plan.serializeBinaryToWriter);
  }
};
/**
 * repeated Plan plans = 1;
 * @return {!Array<!proto.manabie.bob.Plan>}
 */


proto.manabie.bob.RetrievePlansResponse.prototype.getPlansList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Plan>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Plan, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.Plan>} value */


proto.manabie.bob.RetrievePlansResponse.prototype.setPlansList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.Plan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Plan}
 */


proto.manabie.bob.RetrievePlansResponse.prototype.addPlans = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.Plan, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrievePlansResponse.prototype.clearPlansList = function () {
  this.setPlansList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.Package.repeatedFields_ = [5, 15];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.Package.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.Package.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.Package} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.Package.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, 0),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      price: jspb.Message.getFieldWithDefault(msg, 3, 0),
      discountedPrice: jspb.Message.getFieldWithDefault(msg, 4, 0),
      descriptionList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
      notice: jspb.Message.getFieldWithDefault(msg, 6, ""),
      period: (f = msg.getPeriod()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      isRecommended: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
      isEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
      isHidden: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
      carriedOverAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
      planId: jspb.Message.getFieldWithDefault(msg, 12, ""),
      country: jspb.Message.getFieldWithDefault(msg, 13, 0),
      prioritizeLevel: jspb.Message.getFieldWithDefault(msg, 14, 0),
      packageItemsList: jspb.Message.toObjectList(msg.getPackageItemsList(), proto.manabie.bob.PackageItem.toObject, includeInstance),
      iosBundleId: jspb.Message.getFieldWithDefault(msg, 16, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.Package}
 */


proto.manabie.bob.Package.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.Package();
  return proto.manabie.bob.Package.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.Package} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.Package}
 */


proto.manabie.bob.Package.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPrice(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setDiscountedPrice(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addDescription(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setNotice(value);
        break;

      case 7:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setPeriod(value);
        break;

      case 8:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsRecommended(value);
        break;

      case 9:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsEnabled(value);
        break;

      case 10:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsHidden(value);
        break;

      case 11:
        var value =
        /** @type {number} */
        reader.readDouble();
        msg.setCarriedOverAmount(value);
        break;

      case 12:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPlanId(value);
        break;

      case 13:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 14:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPrioritizeLevel(value);
        break;

      case 15:
        var value = new proto.manabie.bob.PackageItem();
        reader.readMessage(value, proto.manabie.bob.PackageItem.deserializeBinaryFromReader);
        msg.addPackageItems(value);
        break;

      case 16:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setIosBundleId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.Package.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.Package.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.Package} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.Package.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getPrice();

  if (f !== 0) {
    writer.writeInt32(3, f);
  }

  f = message.getDiscountedPrice();

  if (f !== 0) {
    writer.writeInt32(4, f);
  }

  f = message.getDescriptionList();

  if (f.length > 0) {
    writer.writeRepeatedString(5, f);
  }

  f = message.getNotice();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getPeriod();

  if (f != null) {
    writer.writeMessage(7, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getIsRecommended();

  if (f) {
    writer.writeBool(8, f);
  }

  f = message.getIsEnabled();

  if (f) {
    writer.writeBool(9, f);
  }

  f = message.getIsHidden();

  if (f) {
    writer.writeBool(10, f);
  }

  f = message.getCarriedOverAmount();

  if (f !== 0.0) {
    writer.writeDouble(11, f);
  }

  f = message.getPlanId();

  if (f.length > 0) {
    writer.writeString(12, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(13, f);
  }

  f = message.getPrioritizeLevel();

  if (f !== 0) {
    writer.writeInt32(14, f);
  }

  f = message.getPackageItemsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(15, f, proto.manabie.bob.PackageItem.serializeBinaryToWriter);
  }

  f = message.getIosBundleId();

  if (f.length > 0) {
    writer.writeString(16, f);
  }
};
/**
 * optional int32 id = 1;
 * @return {number}
 */


proto.manabie.bob.Package.prototype.getId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Package.prototype.setId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.manabie.bob.Package.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Package.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 price = 3;
 * @return {number}
 */


proto.manabie.bob.Package.prototype.getPrice = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Package.prototype.setPrice = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 discounted_price = 4;
 * @return {number}
 */


proto.manabie.bob.Package.prototype.getDiscountedPrice = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Package.prototype.setDiscountedPrice = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * repeated string description = 5;
 * @return {!Array<string>}
 */


proto.manabie.bob.Package.prototype.getDescriptionList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 5)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.Package.prototype.setDescriptionList = function (value) {
  jspb.Message.setField(this, 5, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.Package.prototype.addDescription = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Package.prototype.clearDescriptionList = function () {
  this.setDescriptionList([]);
};
/**
 * optional string notice = 6;
 * @return {string}
 */


proto.manabie.bob.Package.prototype.getNotice = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Package.prototype.setNotice = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional google.protobuf.Timestamp period = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Package.prototype.getPeriod = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Package.prototype.setPeriod = function (value) {
  jspb.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Package.prototype.clearPeriod = function () {
  this.setPeriod(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Package.prototype.hasPeriod = function () {
  return jspb.Message.getField(this, 7) != null;
};
/**
 * optional bool is_recommended = 8;
 * @return {boolean}
 */


proto.manabie.bob.Package.prototype.getIsRecommended = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 8, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.Package.prototype.setIsRecommended = function (value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};
/**
 * optional bool is_enabled = 9;
 * @return {boolean}
 */


proto.manabie.bob.Package.prototype.getIsEnabled = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 9, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.Package.prototype.setIsEnabled = function (value) {
  jspb.Message.setProto3BooleanField(this, 9, value);
};
/**
 * optional bool is_hidden = 10;
 * @return {boolean}
 */


proto.manabie.bob.Package.prototype.getIsHidden = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 10, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.Package.prototype.setIsHidden = function (value) {
  jspb.Message.setProto3BooleanField(this, 10, value);
};
/**
 * optional double carried_over_amount = 11;
 * @return {number}
 */


proto.manabie.bob.Package.prototype.getCarriedOverAmount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.Package.prototype.setCarriedOverAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 11, value);
};
/**
 * optional string plan_id = 12;
 * @return {string}
 */


proto.manabie.bob.Package.prototype.getPlanId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 12, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Package.prototype.setPlanId = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};
/**
 * optional Country country = 13;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.Package.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 13, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.Package.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 13, value);
};
/**
 * optional int32 prioritize_level = 14;
 * @return {number}
 */


proto.manabie.bob.Package.prototype.getPrioritizeLevel = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 14, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Package.prototype.setPrioritizeLevel = function (value) {
  jspb.Message.setProto3IntField(this, 14, value);
};
/**
 * repeated PackageItem package_items = 15;
 * @return {!Array<!proto.manabie.bob.PackageItem>}
 */


proto.manabie.bob.Package.prototype.getPackageItemsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.PackageItem>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.PackageItem, 15)
  );
};
/** @param {!Array<!proto.manabie.bob.PackageItem>} value */


proto.manabie.bob.Package.prototype.setPackageItemsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 15, value);
};
/**
 * @param {!proto.manabie.bob.PackageItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.PackageItem}
 */


proto.manabie.bob.Package.prototype.addPackageItems = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.manabie.bob.PackageItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Package.prototype.clearPackageItemsList = function () {
  this.setPackageItemsList([]);
};
/**
 * optional string ios_bundle_id = 16;
 * @return {string}
 */


proto.manabie.bob.Package.prototype.getIosBundleId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 16, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Package.prototype.setIosBundleId = function (value) {
  jspb.Message.setProto3StringField(this, 16, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.PackageItem.repeatedFields_ = [6, 7];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.PackageItem.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.PackageItem.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.PackageItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.PackageItem.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      packageId: jspb.Message.getFieldWithDefault(msg, 2, 0),
      planId: jspb.Message.getFieldWithDefault(msg, 3, ""),
      expiredAt: (f = msg.getExpiredAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      duration: jspb.Message.getFieldWithDefault(msg, 5, 0),
      subjectList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
      gradesList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.PackageItem}
 */


proto.manabie.bob.PackageItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.PackageItem();
  return proto.manabie.bob.PackageItem.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.PackageItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.PackageItem}
 */


proto.manabie.bob.PackageItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPackageId(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPlanId(value);
        break;

      case 4:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setExpiredAt(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setDuration(value);
        break;

      case 6:
        var value =
        /** @type {!Array<!proto.manabie.bob.Subject>} */
        reader.readPackedEnum();
        msg.setSubjectList(value);
        break;

      case 7:
        var value =
        /** @type {!Array<number>} */
        reader.readPackedInt32();
        msg.setGradesList(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.PackageItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.PackageItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.PackageItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.PackageItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPackageId();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }

  f = message.getPlanId();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getExpiredAt();

  if (f != null) {
    writer.writeMessage(4, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getDuration();

  if (f !== 0) {
    writer.writeInt32(5, f);
  }

  f = message.getSubjectList();

  if (f.length > 0) {
    writer.writePackedEnum(6, f);
  }

  f = message.getGradesList();

  if (f.length > 0) {
    writer.writePackedInt32(7, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.PackageItem.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.PackageItem.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 package_id = 2;
 * @return {number}
 */


proto.manabie.bob.PackageItem.prototype.getPackageId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.PackageItem.prototype.setPackageId = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string plan_id = 3;
 * @return {string}
 */


proto.manabie.bob.PackageItem.prototype.getPlanId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.PackageItem.prototype.setPlanId = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional google.protobuf.Timestamp expired_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.PackageItem.prototype.getExpiredAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.PackageItem.prototype.setExpiredAt = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.PackageItem.prototype.clearExpiredAt = function () {
  this.setExpiredAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.PackageItem.prototype.hasExpiredAt = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * optional int32 duration = 5;
 * @return {number}
 */


proto.manabie.bob.PackageItem.prototype.getDuration = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.PackageItem.prototype.setDuration = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * repeated Subject subject = 6;
 * @return {!Array<!proto.manabie.bob.Subject>}
 */


proto.manabie.bob.PackageItem.prototype.getSubjectList = function () {
  return (
    /** @type {!Array<!proto.manabie.bob.Subject>} */
    jspb.Message.getRepeatedField(this, 6)
  );
};
/** @param {!Array<!proto.manabie.bob.Subject>} value */


proto.manabie.bob.PackageItem.prototype.setSubjectList = function (value) {
  jspb.Message.setField(this, 6, value || []);
};
/**
 * @param {!proto.manabie.bob.Subject} value
 * @param {number=} opt_index
 */


proto.manabie.bob.PackageItem.prototype.addSubject = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.PackageItem.prototype.clearSubjectList = function () {
  this.setSubjectList([]);
};
/**
 * repeated int32 grades = 7;
 * @return {!Array<number>}
 */


proto.manabie.bob.PackageItem.prototype.getGradesList = function () {
  return (
    /** @type {!Array<number>} */
    jspb.Message.getRepeatedField(this, 7)
  );
};
/** @param {!Array<number>} value */


proto.manabie.bob.PackageItem.prototype.setGradesList = function (value) {
  jspb.Message.setField(this, 7, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 */


proto.manabie.bob.PackageItem.prototype.addGrades = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.PackageItem.prototype.clearGradesList = function () {
  this.setGradesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrievePackagesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrievePackagesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrievePackagesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrievePackagesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      planId: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrievePackagesRequest}
 */


proto.manabie.bob.RetrievePackagesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrievePackagesRequest();
  return proto.manabie.bob.RetrievePackagesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrievePackagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrievePackagesRequest}
 */


proto.manabie.bob.RetrievePackagesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPlanId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrievePackagesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrievePackagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrievePackagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrievePackagesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPlanId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string plan_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrievePackagesRequest.prototype.getPlanId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrievePackagesRequest.prototype.setPlanId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrievePackagesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrievePackagesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrievePackagesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrievePackagesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrievePackagesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      packagesList: jspb.Message.toObjectList(msg.getPackagesList(), proto.manabie.bob.Package.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrievePackagesResponse}
 */


proto.manabie.bob.RetrievePackagesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrievePackagesResponse();
  return proto.manabie.bob.RetrievePackagesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrievePackagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrievePackagesResponse}
 */


proto.manabie.bob.RetrievePackagesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Package();
        reader.readMessage(value, proto.manabie.bob.Package.deserializeBinaryFromReader);
        msg.addPackages(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrievePackagesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrievePackagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrievePackagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrievePackagesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPackagesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.Package.serializeBinaryToWriter);
  }
};
/**
 * repeated Package packages = 1;
 * @return {!Array<!proto.manabie.bob.Package>}
 */


proto.manabie.bob.RetrievePackagesResponse.prototype.getPackagesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Package>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Package, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.Package>} value */


proto.manabie.bob.RetrievePackagesResponse.prototype.setPackagesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.Package=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Package}
 */


proto.manabie.bob.RetrievePackagesResponse.prototype.addPackages = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.Package, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrievePackagesResponse.prototype.clearPackagesList = function () {
  this.setPackagesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CreateOnlineOrderRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CreateOnlineOrderRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CreateOnlineOrderRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CreateOnlineOrderRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      packageId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      studentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
      promotionCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
      paymentMethod: jspb.Message.getFieldWithDefault(msg, 4, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CreateOnlineOrderRequest}
 */


proto.manabie.bob.CreateOnlineOrderRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CreateOnlineOrderRequest();
  return proto.manabie.bob.CreateOnlineOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CreateOnlineOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CreateOnlineOrderRequest}
 */


proto.manabie.bob.CreateOnlineOrderRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPackageId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPromotionCode(value);
        break;

      case 4:
        var value =
        /** @type {!proto.manabie.bob.PaymentMethod} */
        reader.readEnum();
        msg.setPaymentMethod(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CreateOnlineOrderRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CreateOnlineOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CreateOnlineOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CreateOnlineOrderRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPackageId();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getPromotionCode();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getPaymentMethod();

  if (f !== 0.0) {
    writer.writeEnum(4, f);
  }
};
/**
 * optional int32 package_id = 1;
 * @return {number}
 */


proto.manabie.bob.CreateOnlineOrderRequest.prototype.getPackageId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.CreateOnlineOrderRequest.prototype.setPackageId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string student_id = 2;
 * @return {string}
 */


proto.manabie.bob.CreateOnlineOrderRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CreateOnlineOrderRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string promotion_code = 3;
 * @return {string}
 */


proto.manabie.bob.CreateOnlineOrderRequest.prototype.getPromotionCode = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CreateOnlineOrderRequest.prototype.setPromotionCode = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional PaymentMethod payment_method = 4;
 * @return {!proto.manabie.bob.PaymentMethod}
 */


proto.manabie.bob.CreateOnlineOrderRequest.prototype.getPaymentMethod = function () {
  return (
    /** @type {!proto.manabie.bob.PaymentMethod} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {!proto.manabie.bob.PaymentMethod} value */


proto.manabie.bob.CreateOnlineOrderRequest.prototype.setPaymentMethod = function (value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CreateOnlineOrderResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CreateOnlineOrderResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CreateOnlineOrderResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CreateOnlineOrderResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
      paymentUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
      orderId: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CreateOnlineOrderResponse}
 */


proto.manabie.bob.CreateOnlineOrderResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CreateOnlineOrderResponse();
  return proto.manabie.bob.CreateOnlineOrderResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CreateOnlineOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CreateOnlineOrderResponse}
 */


proto.manabie.bob.CreateOnlineOrderResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPaymentUrl(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setOrderId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CreateOnlineOrderResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CreateOnlineOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CreateOnlineOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CreateOnlineOrderResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }

  f = message.getPaymentUrl();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getOrderId();

  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.CreateOnlineOrderResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.CreateOnlineOrderResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string payment_url = 2;
 * @return {string}
 */


proto.manabie.bob.CreateOnlineOrderResponse.prototype.getPaymentUrl = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CreateOnlineOrderResponse.prototype.setPaymentUrl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 order_id = 3;
 * @return {number}
 */


proto.manabie.bob.CreateOnlineOrderResponse.prototype.getOrderId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.CreateOnlineOrderResponse.prototype.setOrderId = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CodOrderInfo.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CodOrderInfo.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CodOrderInfo} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CodOrderInfo.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      customerName: jspb.Message.getFieldWithDefault(msg, 1, ""),
      customerPhoneNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
      customerAddress: jspb.Message.getFieldWithDefault(msg, 3, ""),
      expectedDeliveryTime: (f = msg.getExpectedDeliveryTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      status: jspb.Message.getFieldWithDefault(msg, 5, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CodOrderInfo}
 */


proto.manabie.bob.CodOrderInfo.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CodOrderInfo();
  return proto.manabie.bob.CodOrderInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CodOrderInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CodOrderInfo}
 */


proto.manabie.bob.CodOrderInfo.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCustomerName(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCustomerPhoneNumber(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCustomerAddress(value);
        break;

      case 4:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setExpectedDeliveryTime(value);
        break;

      case 5:
        var value =
        /** @type {!proto.manabie.bob.CodOrderStatus} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CodOrderInfo.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CodOrderInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CodOrderInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CodOrderInfo.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCustomerName();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getCustomerPhoneNumber();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCustomerAddress();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getExpectedDeliveryTime();

  if (f != null) {
    writer.writeMessage(4, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(5, f);
  }
};
/**
 * optional string customer_name = 1;
 * @return {string}
 */


proto.manabie.bob.CodOrderInfo.prototype.getCustomerName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CodOrderInfo.prototype.setCustomerName = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_phone_number = 2;
 * @return {string}
 */


proto.manabie.bob.CodOrderInfo.prototype.getCustomerPhoneNumber = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CodOrderInfo.prototype.setCustomerPhoneNumber = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_address = 3;
 * @return {string}
 */


proto.manabie.bob.CodOrderInfo.prototype.getCustomerAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CodOrderInfo.prototype.setCustomerAddress = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional google.protobuf.Timestamp expected_delivery_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.CodOrderInfo.prototype.getExpectedDeliveryTime = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.CodOrderInfo.prototype.setExpectedDeliveryTime = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.CodOrderInfo.prototype.clearExpectedDeliveryTime = function () {
  this.setExpectedDeliveryTime(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.CodOrderInfo.prototype.hasExpectedDeliveryTime = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * optional CodOrderStatus status = 5;
 * @return {!proto.manabie.bob.CodOrderStatus}
 */


proto.manabie.bob.CodOrderInfo.prototype.getStatus = function () {
  return (
    /** @type {!proto.manabie.bob.CodOrderStatus} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {!proto.manabie.bob.CodOrderStatus} value */


proto.manabie.bob.CodOrderInfo.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.StudentSubscription.repeatedFields_ = [2, 3];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.StudentSubscription.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.StudentSubscription.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.StudentSubscription} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.StudentSubscription.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      planId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      gradesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
      subjectsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
      start: (f = msg.getStart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      end: (f = msg.getEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      status: jspb.Message.getFieldWithDefault(msg, 6, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.StudentSubscription}
 */


proto.manabie.bob.StudentSubscription.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.StudentSubscription();
  return proto.manabie.bob.StudentSubscription.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.StudentSubscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.StudentSubscription}
 */


proto.manabie.bob.StudentSubscription.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPlanId(value);
        break;

      case 2:
        var value =
        /** @type {!Array<number>} */
        reader.readPackedInt32();
        msg.setGradesList(value);
        break;

      case 3:
        var value =
        /** @type {!Array<!proto.manabie.bob.Subject>} */
        reader.readPackedEnum();
        msg.setSubjectsList(value);
        break;

      case 4:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setStart(value);
        break;

      case 5:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setEnd(value);
        break;

      case 6:
        var value =
        /** @type {!proto.manabie.bob.SubscriptionStatus} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.StudentSubscription.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.StudentSubscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.StudentSubscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.StudentSubscription.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPlanId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getGradesList();

  if (f.length > 0) {
    writer.writePackedInt32(2, f);
  }

  f = message.getSubjectsList();

  if (f.length > 0) {
    writer.writePackedEnum(3, f);
  }

  f = message.getStart();

  if (f != null) {
    writer.writeMessage(4, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getEnd();

  if (f != null) {
    writer.writeMessage(5, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(6, f);
  }
};
/**
 * optional string plan_id = 1;
 * @return {string}
 */


proto.manabie.bob.StudentSubscription.prototype.getPlanId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentSubscription.prototype.setPlanId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated int32 grades = 2;
 * @return {!Array<number>}
 */


proto.manabie.bob.StudentSubscription.prototype.getGradesList = function () {
  return (
    /** @type {!Array<number>} */
    jspb.Message.getRepeatedField(this, 2)
  );
};
/** @param {!Array<number>} value */


proto.manabie.bob.StudentSubscription.prototype.setGradesList = function (value) {
  jspb.Message.setField(this, 2, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 */


proto.manabie.bob.StudentSubscription.prototype.addGrades = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.StudentSubscription.prototype.clearGradesList = function () {
  this.setGradesList([]);
};
/**
 * repeated Subject subjects = 3;
 * @return {!Array<!proto.manabie.bob.Subject>}
 */


proto.manabie.bob.StudentSubscription.prototype.getSubjectsList = function () {
  return (
    /** @type {!Array<!proto.manabie.bob.Subject>} */
    jspb.Message.getRepeatedField(this, 3)
  );
};
/** @param {!Array<!proto.manabie.bob.Subject>} value */


proto.manabie.bob.StudentSubscription.prototype.setSubjectsList = function (value) {
  jspb.Message.setField(this, 3, value || []);
};
/**
 * @param {!proto.manabie.bob.Subject} value
 * @param {number=} opt_index
 */


proto.manabie.bob.StudentSubscription.prototype.addSubjects = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.StudentSubscription.prototype.clearSubjectsList = function () {
  this.setSubjectsList([]);
};
/**
 * optional google.protobuf.Timestamp start = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.StudentSubscription.prototype.getStart = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.StudentSubscription.prototype.setStart = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.StudentSubscription.prototype.clearStart = function () {
  this.setStart(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.StudentSubscription.prototype.hasStart = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * optional google.protobuf.Timestamp end = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.StudentSubscription.prototype.getEnd = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.StudentSubscription.prototype.setEnd = function (value) {
  jspb.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.StudentSubscription.prototype.clearEnd = function () {
  this.setEnd(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.StudentSubscription.prototype.hasEnd = function () {
  return jspb.Message.getField(this, 5) != null;
};
/**
 * optional SubscriptionStatus status = 6;
 * @return {!proto.manabie.bob.SubscriptionStatus}
 */


proto.manabie.bob.StudentSubscription.prototype.getStatus = function () {
  return (
    /** @type {!proto.manabie.bob.SubscriptionStatus} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/** @param {!proto.manabie.bob.SubscriptionStatus} value */


proto.manabie.bob.StudentSubscription.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.Order.repeatedFields_ = [25];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.Order.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.Order.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.Order} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.Order.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, 0),
      amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
      planId: jspb.Message.getFieldWithDefault(msg, 3, ""),
      planName: jspb.Message.getFieldWithDefault(msg, 4, ""),
      manualCreatedBy: jspb.Message.getFieldWithDefault(msg, 5, ""),
      status: jspb.Message.getFieldWithDefault(msg, 6, 0),
      coupon: jspb.Message.getFieldWithDefault(msg, 7, ""),
      couponAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
      carriedOverAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
      carriedOverFrom: jspb.Message.getFieldWithDefault(msg, 10, 0),
      start: (f = msg.getStart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      end: (f = msg.getEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      currency: jspb.Message.getFieldWithDefault(msg, 15, ""),
      paymentMethod: jspb.Message.getFieldWithDefault(msg, 16, ""),
      paymentLink: jspb.Message.getFieldWithDefault(msg, 17, ""),
      packageId: jspb.Message.getFieldWithDefault(msg, 18, 0),
      packageName: jspb.Message.getFieldWithDefault(msg, 19, ""),
      country: jspb.Message.getFieldWithDefault(msg, 20, 0),
      studentId: jspb.Message.getFieldWithDefault(msg, 21, ""),
      referenceNumber: jspb.Message.getFieldWithDefault(msg, 22, ""),
      codOrderInfo: (f = msg.getCodOrderInfo()) && proto.manabie.bob.CodOrderInfo.toObject(includeInstance, f),
      mustPayBefore: (f = msg.getMustPayBefore()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      subscriptionsList: jspb.Message.toObjectList(msg.getSubscriptionsList(), proto.manabie.bob.StudentSubscription.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.Order}
 */


proto.manabie.bob.Order.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.Order();
  return proto.manabie.bob.Order.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.Order} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.Order}
 */


proto.manabie.bob.Order.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readDouble();
        msg.setAmount(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPlanId(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPlanName(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setManualCreatedBy(value);
        break;

      case 6:
        var value =
        /** @type {!proto.manabie.bob.OrderStatus} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCoupon(value);
        break;

      case 8:
        var value =
        /** @type {number} */
        reader.readDouble();
        msg.setCouponAmount(value);
        break;

      case 9:
        var value =
        /** @type {number} */
        reader.readDouble();
        msg.setCarriedOverAmount(value);
        break;

      case 10:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setCarriedOverFrom(value);
        break;

      case 11:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setStart(value);
        break;

      case 12:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setEnd(value);
        break;

      case 13:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      case 14:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      case 15:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCurrency(value);
        break;

      case 16:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPaymentMethod(value);
        break;

      case 17:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPaymentLink(value);
        break;

      case 18:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPackageId(value);
        break;

      case 19:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPackageName(value);
        break;

      case 20:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 21:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 22:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setReferenceNumber(value);
        break;

      case 23:
        var value = new proto.manabie.bob.CodOrderInfo();
        reader.readMessage(value, proto.manabie.bob.CodOrderInfo.deserializeBinaryFromReader);
        msg.setCodOrderInfo(value);
        break;

      case 24:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setMustPayBefore(value);
        break;

      case 25:
        var value = new proto.manabie.bob.StudentSubscription();
        reader.readMessage(value, proto.manabie.bob.StudentSubscription.deserializeBinaryFromReader);
        msg.addSubscriptions(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.Order.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.Order.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.Order} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.Order.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getAmount();

  if (f !== 0.0) {
    writer.writeDouble(2, f);
  }

  f = message.getPlanId();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getPlanName();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getManualCreatedBy();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(6, f);
  }

  f = message.getCoupon();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getCouponAmount();

  if (f !== 0.0) {
    writer.writeDouble(8, f);
  }

  f = message.getCarriedOverAmount();

  if (f !== 0.0) {
    writer.writeDouble(9, f);
  }

  f = message.getCarriedOverFrom();

  if (f !== 0) {
    writer.writeInt32(10, f);
  }

  f = message.getStart();

  if (f != null) {
    writer.writeMessage(11, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getEnd();

  if (f != null) {
    writer.writeMessage(12, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(13, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(14, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getCurrency();

  if (f.length > 0) {
    writer.writeString(15, f);
  }

  f = message.getPaymentMethod();

  if (f.length > 0) {
    writer.writeString(16, f);
  }

  f = message.getPaymentLink();

  if (f.length > 0) {
    writer.writeString(17, f);
  }

  f = message.getPackageId();

  if (f !== 0) {
    writer.writeInt32(18, f);
  }

  f = message.getPackageName();

  if (f.length > 0) {
    writer.writeString(19, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(20, f);
  }

  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(21, f);
  }

  f = message.getReferenceNumber();

  if (f.length > 0) {
    writer.writeString(22, f);
  }

  f = message.getCodOrderInfo();

  if (f != null) {
    writer.writeMessage(23, f, proto.manabie.bob.CodOrderInfo.serializeBinaryToWriter);
  }

  f = message.getMustPayBefore();

  if (f != null) {
    writer.writeMessage(24, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getSubscriptionsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(25, f, proto.manabie.bob.StudentSubscription.serializeBinaryToWriter);
  }
};
/**
 * optional int32 id = 1;
 * @return {number}
 */


proto.manabie.bob.Order.prototype.getId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Order.prototype.setId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional double amount = 2;
 * @return {number}
 */


proto.manabie.bob.Order.prototype.getAmount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.Order.prototype.setAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};
/**
 * optional string plan_id = 3;
 * @return {string}
 */


proto.manabie.bob.Order.prototype.getPlanId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Order.prototype.setPlanId = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string plan_name = 4;
 * @return {string}
 */


proto.manabie.bob.Order.prototype.getPlanName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Order.prototype.setPlanName = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string manual_created_by = 5;
 * @return {string}
 */


proto.manabie.bob.Order.prototype.getManualCreatedBy = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Order.prototype.setManualCreatedBy = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional OrderStatus status = 6;
 * @return {!proto.manabie.bob.OrderStatus}
 */


proto.manabie.bob.Order.prototype.getStatus = function () {
  return (
    /** @type {!proto.manabie.bob.OrderStatus} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/** @param {!proto.manabie.bob.OrderStatus} value */


proto.manabie.bob.Order.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional string coupon = 7;
 * @return {string}
 */


proto.manabie.bob.Order.prototype.getCoupon = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Order.prototype.setCoupon = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional double coupon_amount = 8;
 * @return {number}
 */


proto.manabie.bob.Order.prototype.getCouponAmount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.Order.prototype.setCouponAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional double carried_over_amount = 9;
 * @return {number}
 */


proto.manabie.bob.Order.prototype.getCarriedOverAmount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.Order.prototype.setCarriedOverAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 9, value);
};
/**
 * optional int32 carried_over_from = 10;
 * @return {number}
 */


proto.manabie.bob.Order.prototype.getCarriedOverFrom = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Order.prototype.setCarriedOverFrom = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};
/**
 * optional google.protobuf.Timestamp start = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Order.prototype.getStart = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Order.prototype.setStart = function (value) {
  jspb.Message.setWrapperField(this, 11, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Order.prototype.clearStart = function () {
  this.setStart(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Order.prototype.hasStart = function () {
  return jspb.Message.getField(this, 11) != null;
};
/**
 * optional google.protobuf.Timestamp end = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Order.prototype.getEnd = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Order.prototype.setEnd = function (value) {
  jspb.Message.setWrapperField(this, 12, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Order.prototype.clearEnd = function () {
  this.setEnd(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Order.prototype.hasEnd = function () {
  return jspb.Message.getField(this, 12) != null;
};
/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Order.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Order.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 13, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Order.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Order.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 13) != null;
};
/**
 * optional google.protobuf.Timestamp created_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Order.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Order.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 14, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Order.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Order.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 14) != null;
};
/**
 * optional string currency = 15;
 * @return {string}
 */


proto.manabie.bob.Order.prototype.getCurrency = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 15, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Order.prototype.setCurrency = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};
/**
 * optional string payment_method = 16;
 * @return {string}
 */


proto.manabie.bob.Order.prototype.getPaymentMethod = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 16, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Order.prototype.setPaymentMethod = function (value) {
  jspb.Message.setProto3StringField(this, 16, value);
};
/**
 * optional string payment_link = 17;
 * @return {string}
 */


proto.manabie.bob.Order.prototype.getPaymentLink = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 17, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Order.prototype.setPaymentLink = function (value) {
  jspb.Message.setProto3StringField(this, 17, value);
};
/**
 * optional int32 package_id = 18;
 * @return {number}
 */


proto.manabie.bob.Order.prototype.getPackageId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 18, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Order.prototype.setPackageId = function (value) {
  jspb.Message.setProto3IntField(this, 18, value);
};
/**
 * optional string package_name = 19;
 * @return {string}
 */


proto.manabie.bob.Order.prototype.getPackageName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 19, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Order.prototype.setPackageName = function (value) {
  jspb.Message.setProto3StringField(this, 19, value);
};
/**
 * optional Country country = 20;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.Order.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 20, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.Order.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 20, value);
};
/**
 * optional string student_id = 21;
 * @return {string}
 */


proto.manabie.bob.Order.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 21, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Order.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 21, value);
};
/**
 * optional string reference_number = 22;
 * @return {string}
 */


proto.manabie.bob.Order.prototype.getReferenceNumber = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 22, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Order.prototype.setReferenceNumber = function (value) {
  jspb.Message.setProto3StringField(this, 22, value);
};
/**
 * optional CodOrderInfo cod_order_info = 23;
 * @return {?proto.manabie.bob.CodOrderInfo}
 */


proto.manabie.bob.Order.prototype.getCodOrderInfo = function () {
  return (
    /** @type{?proto.manabie.bob.CodOrderInfo} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.CodOrderInfo, 23)
  );
};
/** @param {?proto.manabie.bob.CodOrderInfo|undefined} value */


proto.manabie.bob.Order.prototype.setCodOrderInfo = function (value) {
  jspb.Message.setWrapperField(this, 23, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Order.prototype.clearCodOrderInfo = function () {
  this.setCodOrderInfo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Order.prototype.hasCodOrderInfo = function () {
  return jspb.Message.getField(this, 23) != null;
};
/**
 * optional google.protobuf.Timestamp must_pay_before = 24;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Order.prototype.getMustPayBefore = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 24)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Order.prototype.setMustPayBefore = function (value) {
  jspb.Message.setWrapperField(this, 24, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Order.prototype.clearMustPayBefore = function () {
  this.setMustPayBefore(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Order.prototype.hasMustPayBefore = function () {
  return jspb.Message.getField(this, 24) != null;
};
/**
 * repeated StudentSubscription subscriptions = 25;
 * @return {!Array<!proto.manabie.bob.StudentSubscription>}
 */


proto.manabie.bob.Order.prototype.getSubscriptionsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.StudentSubscription>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.StudentSubscription, 25)
  );
};
/** @param {!Array<!proto.manabie.bob.StudentSubscription>} value */


proto.manabie.bob.Order.prototype.setSubscriptionsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 25, value);
};
/**
 * @param {!proto.manabie.bob.StudentSubscription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.StudentSubscription}
 */


proto.manabie.bob.Order.prototype.addSubscriptions = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 25, opt_value, proto.manabie.bob.StudentSubscription, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Order.prototype.clearSubscriptionsList = function () {
  this.setSubscriptionsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.ListOrdersRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ListOrdersRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ListOrdersRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ListOrdersRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ListOrdersRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
      status: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ListOrdersRequest}
 */


proto.manabie.bob.ListOrdersRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ListOrdersRequest();
  return proto.manabie.bob.ListOrdersRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ListOrdersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ListOrdersRequest}
 */


proto.manabie.bob.ListOrdersRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addStudentIds(value);
        break;

      case 2:
        var value =
        /** @type {!proto.manabie.bob.OrderStatus} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ListOrdersRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ListOrdersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ListOrdersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ListOrdersRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }

  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
};
/**
 * repeated string student_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.ListOrdersRequest.prototype.getStudentIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.ListOrdersRequest.prototype.setStudentIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.ListOrdersRequest.prototype.addStudentIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.ListOrdersRequest.prototype.clearStudentIdsList = function () {
  this.setStudentIdsList([]);
};
/**
 * optional OrderStatus status = 2;
 * @return {!proto.manabie.bob.OrderStatus}
 */


proto.manabie.bob.ListOrdersRequest.prototype.getStatus = function () {
  return (
    /** @type {!proto.manabie.bob.OrderStatus} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {!proto.manabie.bob.OrderStatus} value */


proto.manabie.bob.ListOrdersRequest.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.ListOrdersResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ListOrdersResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ListOrdersResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ListOrdersResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ListOrdersResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      ordersList: jspb.Message.toObjectList(msg.getOrdersList(), proto.manabie.bob.Order.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ListOrdersResponse}
 */


proto.manabie.bob.ListOrdersResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ListOrdersResponse();
  return proto.manabie.bob.ListOrdersResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ListOrdersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ListOrdersResponse}
 */


proto.manabie.bob.ListOrdersResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Order();
        reader.readMessage(value, proto.manabie.bob.Order.deserializeBinaryFromReader);
        msg.addOrders(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ListOrdersResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ListOrdersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ListOrdersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ListOrdersResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrdersList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.Order.serializeBinaryToWriter);
  }
};
/**
 * repeated Order orders = 1;
 * @return {!Array<!proto.manabie.bob.Order>}
 */


proto.manabie.bob.ListOrdersResponse.prototype.getOrdersList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Order>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Order, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.Order>} value */


proto.manabie.bob.ListOrdersResponse.prototype.setOrdersList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.Order=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Order}
 */


proto.manabie.bob.ListOrdersResponse.prototype.addOrders = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.Order, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.ListOrdersResponse.prototype.clearOrdersList = function () {
  this.setOrdersList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateAsiaPayOrderRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateAsiaPayOrderRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateAsiaPayOrderRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateAsiaPayOrderRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      orderId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      responseCode: jspb.Message.getFieldWithDefault(msg, 2, 0),
      fullResponse: jspb.Message.getFieldWithDefault(msg, 3, ""),
      paymentMethod: jspb.Message.getFieldWithDefault(msg, 4, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateAsiaPayOrderRequest}
 */


proto.manabie.bob.UpdateAsiaPayOrderRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateAsiaPayOrderRequest();
  return proto.manabie.bob.UpdateAsiaPayOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateAsiaPayOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateAsiaPayOrderRequest}
 */


proto.manabie.bob.UpdateAsiaPayOrderRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setOrderId(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setResponseCode(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setFullResponse(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPaymentMethod(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateAsiaPayOrderRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateAsiaPayOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateAsiaPayOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateAsiaPayOrderRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrderId();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getResponseCode();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }

  f = message.getFullResponse();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getPaymentMethod();

  if (f.length > 0) {
    writer.writeString(4, f);
  }
};
/**
 * optional int32 order_id = 1;
 * @return {number}
 */


proto.manabie.bob.UpdateAsiaPayOrderRequest.prototype.getOrderId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.UpdateAsiaPayOrderRequest.prototype.setOrderId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 response_code = 2;
 * @return {number}
 */


proto.manabie.bob.UpdateAsiaPayOrderRequest.prototype.getResponseCode = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.UpdateAsiaPayOrderRequest.prototype.setResponseCode = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string full_response = 3;
 * @return {string}
 */


proto.manabie.bob.UpdateAsiaPayOrderRequest.prototype.getFullResponse = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UpdateAsiaPayOrderRequest.prototype.setFullResponse = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string payment_method = 4;
 * @return {string}
 */


proto.manabie.bob.UpdateAsiaPayOrderRequest.prototype.getPaymentMethod = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UpdateAsiaPayOrderRequest.prototype.setPaymentMethod = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateAsiaPayOrderResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateAsiaPayOrderResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateAsiaPayOrderResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateAsiaPayOrderResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateAsiaPayOrderResponse}
 */


proto.manabie.bob.UpdateAsiaPayOrderResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateAsiaPayOrderResponse();
  return proto.manabie.bob.UpdateAsiaPayOrderResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateAsiaPayOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateAsiaPayOrderResponse}
 */


proto.manabie.bob.UpdateAsiaPayOrderResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateAsiaPayOrderResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateAsiaPayOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateAsiaPayOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateAsiaPayOrderResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.UpdateAsiaPayOrderResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.UpdateAsiaPayOrderResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CreateManualOrderRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CreateManualOrderRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CreateManualOrderRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CreateManualOrderRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      order: (f = msg.getOrder()) && proto.manabie.bob.Order.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CreateManualOrderRequest}
 */


proto.manabie.bob.CreateManualOrderRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CreateManualOrderRequest();
  return proto.manabie.bob.CreateManualOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CreateManualOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CreateManualOrderRequest}
 */


proto.manabie.bob.CreateManualOrderRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Order();
        reader.readMessage(value, proto.manabie.bob.Order.deserializeBinaryFromReader);
        msg.setOrder(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CreateManualOrderRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CreateManualOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CreateManualOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CreateManualOrderRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrder();

  if (f != null) {
    writer.writeMessage(1, f, proto.manabie.bob.Order.serializeBinaryToWriter);
  }
};
/**
 * optional Order order = 1;
 * @return {?proto.manabie.bob.Order}
 */


proto.manabie.bob.CreateManualOrderRequest.prototype.getOrder = function () {
  return (
    /** @type{?proto.manabie.bob.Order} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.Order, 1)
  );
};
/** @param {?proto.manabie.bob.Order|undefined} value */


proto.manabie.bob.CreateManualOrderRequest.prototype.setOrder = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.CreateManualOrderRequest.prototype.clearOrder = function () {
  this.setOrder(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.CreateManualOrderRequest.prototype.hasOrder = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CreateManualOrderResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CreateManualOrderResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CreateManualOrderResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CreateManualOrderResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CreateManualOrderResponse}
 */


proto.manabie.bob.CreateManualOrderResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CreateManualOrderResponse();
  return proto.manabie.bob.CreateManualOrderResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CreateManualOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CreateManualOrderResponse}
 */


proto.manabie.bob.CreateManualOrderResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CreateManualOrderResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CreateManualOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CreateManualOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CreateManualOrderResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.CreateManualOrderResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.CreateManualOrderResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.DisableOrderRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.DisableOrderRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.DisableOrderRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.DisableOrderRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      orderId: jspb.Message.getFieldWithDefault(msg, 1, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.DisableOrderRequest}
 */


proto.manabie.bob.DisableOrderRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.DisableOrderRequest();
  return proto.manabie.bob.DisableOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.DisableOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.DisableOrderRequest}
 */


proto.manabie.bob.DisableOrderRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setOrderId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.DisableOrderRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.DisableOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.DisableOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.DisableOrderRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrderId();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }
};
/**
 * optional int32 order_id = 1;
 * @return {number}
 */


proto.manabie.bob.DisableOrderRequest.prototype.getOrderId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.DisableOrderRequest.prototype.setOrderId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.DisableOrderResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.DisableOrderResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.DisableOrderResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.DisableOrderResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.DisableOrderResponse}
 */


proto.manabie.bob.DisableOrderResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.DisableOrderResponse();
  return proto.manabie.bob.DisableOrderResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.DisableOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.DisableOrderResponse}
 */


proto.manabie.bob.DisableOrderResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.DisableOrderResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.DisableOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.DisableOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.DisableOrderResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.DisableOrderResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.DisableOrderResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrievePromotionCodePrefixesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrievePromotionCodePrefixesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrievePromotionCodePrefixesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrievePromotionCodePrefixesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrievePromotionCodePrefixesRequest}
 */


proto.manabie.bob.RetrievePromotionCodePrefixesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrievePromotionCodePrefixesRequest();
  return proto.manabie.bob.RetrievePromotionCodePrefixesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrievePromotionCodePrefixesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrievePromotionCodePrefixesRequest}
 */


proto.manabie.bob.RetrievePromotionCodePrefixesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrievePromotionCodePrefixesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrievePromotionCodePrefixesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrievePromotionCodePrefixesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrievePromotionCodePrefixesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrievePromotionCodePrefixesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrievePromotionCodePrefixesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrievePromotionCodePrefixesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrievePromotionCodePrefixesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrievePromotionCodePrefixesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      prefixesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrievePromotionCodePrefixesResponse}
 */


proto.manabie.bob.RetrievePromotionCodePrefixesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrievePromotionCodePrefixesResponse();
  return proto.manabie.bob.RetrievePromotionCodePrefixesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrievePromotionCodePrefixesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrievePromotionCodePrefixesResponse}
 */


proto.manabie.bob.RetrievePromotionCodePrefixesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addPrefixes(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrievePromotionCodePrefixesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrievePromotionCodePrefixesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrievePromotionCodePrefixesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrievePromotionCodePrefixesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPrefixesList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string prefixes = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.RetrievePromotionCodePrefixesResponse.prototype.getPrefixesList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.RetrievePromotionCodePrefixesResponse.prototype.setPrefixesList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.RetrievePromotionCodePrefixesResponse.prototype.addPrefixes = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrievePromotionCodePrefixesResponse.prototype.clearPrefixesList = function () {
  this.setPrefixesList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.Promotion.repeatedFields_ = [13];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.Promotion.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.Promotion.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.Promotion} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.Promotion.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      promoType: jspb.Message.getFieldWithDefault(msg, 1, 0),
      country: jspb.Message.getFieldWithDefault(msg, 2, 0),
      codePrefix: jspb.Message.getFieldWithDefault(msg, 3, ""),
      code: jspb.Message.getFieldWithDefault(msg, 4, ""),
      discountType: jspb.Message.getFieldWithDefault(msg, 5, 0),
      discountAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
      status: jspb.Message.getFieldWithDefault(msg, 7, 0),
      startedDate: (f = msg.getStartedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      expiredDate: (f = msg.getExpiredDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      redemptionLimitPerCode: jspb.Message.getFieldWithDefault(msg, 10, 0),
      redemptionLimitPerUser: jspb.Message.getFieldWithDefault(msg, 11, 0),
      notes: jspb.Message.getFieldWithDefault(msg, 12, ""),
      rulesList: jspb.Message.toObjectList(msg.getRulesList(), proto.manabie.bob.PromotionRule.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.Promotion}
 */


proto.manabie.bob.Promotion.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.Promotion();
  return proto.manabie.bob.Promotion.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.Promotion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.Promotion}
 */


proto.manabie.bob.Promotion.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!proto.manabie.bob.PromoType} */
        reader.readEnum();
        msg.setPromoType(value);
        break;

      case 2:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCodePrefix(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCode(value);
        break;

      case 5:
        var value =
        /** @type {!proto.manabie.bob.PromoDiscountType} */
        reader.readEnum();
        msg.setDiscountType(value);
        break;

      case 6:
        var value =
        /** @type {number} */
        reader.readDouble();
        msg.setDiscountAmount(value);
        break;

      case 7:
        var value =
        /** @type {!proto.manabie.bob.PromoStatus} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      case 8:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setStartedDate(value);
        break;

      case 9:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setExpiredDate(value);
        break;

      case 10:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setRedemptionLimitPerCode(value);
        break;

      case 11:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setRedemptionLimitPerUser(value);
        break;

      case 12:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setNotes(value);
        break;

      case 13:
        var value = new proto.manabie.bob.PromotionRule();
        reader.readMessage(value, proto.manabie.bob.PromotionRule.deserializeBinaryFromReader);
        msg.addRules(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.Promotion.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.Promotion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.Promotion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.Promotion.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPromoType();

  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }

  f = message.getCodePrefix();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getCode();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getDiscountType();

  if (f !== 0.0) {
    writer.writeEnum(5, f);
  }

  f = message.getDiscountAmount();

  if (f !== 0.0) {
    writer.writeDouble(6, f);
  }

  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(7, f);
  }

  f = message.getStartedDate();

  if (f != null) {
    writer.writeMessage(8, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getExpiredDate();

  if (f != null) {
    writer.writeMessage(9, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getRedemptionLimitPerCode();

  if (f !== 0) {
    writer.writeInt32(10, f);
  }

  f = message.getRedemptionLimitPerUser();

  if (f !== 0) {
    writer.writeInt32(11, f);
  }

  f = message.getNotes();

  if (f.length > 0) {
    writer.writeString(12, f);
  }

  f = message.getRulesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(13, f, proto.manabie.bob.PromotionRule.serializeBinaryToWriter);
  }
};
/**
 * optional PromoType promo_type = 1;
 * @return {!proto.manabie.bob.PromoType}
 */


proto.manabie.bob.Promotion.prototype.getPromoType = function () {
  return (
    /** @type {!proto.manabie.bob.PromoType} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {!proto.manabie.bob.PromoType} value */


proto.manabie.bob.Promotion.prototype.setPromoType = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional Country country = 2;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.Promotion.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.Promotion.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string code_prefix = 3;
 * @return {string}
 */


proto.manabie.bob.Promotion.prototype.getCodePrefix = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Promotion.prototype.setCodePrefix = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string code = 4;
 * @return {string}
 */


proto.manabie.bob.Promotion.prototype.getCode = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Promotion.prototype.setCode = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional PromoDiscountType discount_type = 5;
 * @return {!proto.manabie.bob.PromoDiscountType}
 */


proto.manabie.bob.Promotion.prototype.getDiscountType = function () {
  return (
    /** @type {!proto.manabie.bob.PromoDiscountType} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {!proto.manabie.bob.PromoDiscountType} value */


proto.manabie.bob.Promotion.prototype.setDiscountType = function (value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional double discount_amount = 6;
 * @return {number}
 */


proto.manabie.bob.Promotion.prototype.getDiscountAmount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.Promotion.prototype.setDiscountAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 6, value);
};
/**
 * optional PromoStatus status = 7;
 * @return {!proto.manabie.bob.PromoStatus}
 */


proto.manabie.bob.Promotion.prototype.getStatus = function () {
  return (
    /** @type {!proto.manabie.bob.PromoStatus} */
    jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};
/** @param {!proto.manabie.bob.PromoStatus} value */


proto.manabie.bob.Promotion.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};
/**
 * optional google.protobuf.Timestamp started_date = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Promotion.prototype.getStartedDate = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Promotion.prototype.setStartedDate = function (value) {
  jspb.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Promotion.prototype.clearStartedDate = function () {
  this.setStartedDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Promotion.prototype.hasStartedDate = function () {
  return jspb.Message.getField(this, 8) != null;
};
/**
 * optional google.protobuf.Timestamp expired_date = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Promotion.prototype.getExpiredDate = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Promotion.prototype.setExpiredDate = function (value) {
  jspb.Message.setWrapperField(this, 9, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Promotion.prototype.clearExpiredDate = function () {
  this.setExpiredDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Promotion.prototype.hasExpiredDate = function () {
  return jspb.Message.getField(this, 9) != null;
};
/**
 * optional int32 redemption_limit_per_code = 10;
 * @return {number}
 */


proto.manabie.bob.Promotion.prototype.getRedemptionLimitPerCode = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Promotion.prototype.setRedemptionLimitPerCode = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};
/**
 * optional int32 redemption_limit_per_user = 11;
 * @return {number}
 */


proto.manabie.bob.Promotion.prototype.getRedemptionLimitPerUser = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 11, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Promotion.prototype.setRedemptionLimitPerUser = function (value) {
  jspb.Message.setProto3IntField(this, 11, value);
};
/**
 * optional string notes = 12;
 * @return {string}
 */


proto.manabie.bob.Promotion.prototype.getNotes = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 12, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Promotion.prototype.setNotes = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};
/**
 * repeated PromotionRule rules = 13;
 * @return {!Array<!proto.manabie.bob.PromotionRule>}
 */


proto.manabie.bob.Promotion.prototype.getRulesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.PromotionRule>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.PromotionRule, 13)
  );
};
/** @param {!Array<!proto.manabie.bob.PromotionRule>} value */


proto.manabie.bob.Promotion.prototype.setRulesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 13, value);
};
/**
 * @param {!proto.manabie.bob.PromotionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.PromotionRule}
 */


proto.manabie.bob.Promotion.prototype.addRules = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.manabie.bob.PromotionRule, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Promotion.prototype.clearRulesList = function () {
  this.setRulesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.PromotionRule.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.PromotionRule.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.PromotionRule} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.PromotionRule.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      promoType: jspb.Message.getFieldWithDefault(msg, 1, 0),
      discountType: jspb.Message.getFieldWithDefault(msg, 2, 0),
      discountAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
      conditions: (f = msg.getConditions()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
      rewards: (f = msg.getRewards()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.PromotionRule}
 */


proto.manabie.bob.PromotionRule.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.PromotionRule();
  return proto.manabie.bob.PromotionRule.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.PromotionRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.PromotionRule}
 */


proto.manabie.bob.PromotionRule.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!proto.manabie.bob.PromoType} */
        reader.readEnum();
        msg.setPromoType(value);
        break;

      case 2:
        var value =
        /** @type {!proto.manabie.bob.PromoDiscountType} */
        reader.readEnum();
        msg.setDiscountType(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readDouble();
        msg.setDiscountAmount(value);
        break;

      case 4:
        var value = new google_protobuf_struct_pb.Struct();
        reader.readMessage(value, google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
        msg.setConditions(value);
        break;

      case 5:
        var value = new google_protobuf_struct_pb.Struct();
        reader.readMessage(value, google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
        msg.setRewards(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.PromotionRule.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.PromotionRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.PromotionRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.PromotionRule.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPromoType();

  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }

  f = message.getDiscountType();

  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }

  f = message.getDiscountAmount();

  if (f !== 0.0) {
    writer.writeDouble(3, f);
  }

  f = message.getConditions();

  if (f != null) {
    writer.writeMessage(4, f, google_protobuf_struct_pb.Struct.serializeBinaryToWriter);
  }

  f = message.getRewards();

  if (f != null) {
    writer.writeMessage(5, f, google_protobuf_struct_pb.Struct.serializeBinaryToWriter);
  }
};
/**
 * optional PromoType promo_type = 1;
 * @return {!proto.manabie.bob.PromoType}
 */


proto.manabie.bob.PromotionRule.prototype.getPromoType = function () {
  return (
    /** @type {!proto.manabie.bob.PromoType} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {!proto.manabie.bob.PromoType} value */


proto.manabie.bob.PromotionRule.prototype.setPromoType = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional PromoDiscountType discount_type = 2;
 * @return {!proto.manabie.bob.PromoDiscountType}
 */


proto.manabie.bob.PromotionRule.prototype.getDiscountType = function () {
  return (
    /** @type {!proto.manabie.bob.PromoDiscountType} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {!proto.manabie.bob.PromoDiscountType} value */


proto.manabie.bob.PromotionRule.prototype.setDiscountType = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional double discount_amount = 3;
 * @return {number}
 */


proto.manabie.bob.PromotionRule.prototype.getDiscountAmount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.PromotionRule.prototype.setDiscountAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};
/**
 * optional google.protobuf.Struct conditions = 4;
 * @return {?proto.google.protobuf.Struct}
 */


proto.manabie.bob.PromotionRule.prototype.getConditions = function () {
  return (
    /** @type{?proto.google.protobuf.Struct} */
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 4)
  );
};
/** @param {?proto.google.protobuf.Struct|undefined} value */


proto.manabie.bob.PromotionRule.prototype.setConditions = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.PromotionRule.prototype.clearConditions = function () {
  this.setConditions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.PromotionRule.prototype.hasConditions = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * optional google.protobuf.Struct rewards = 5;
 * @return {?proto.google.protobuf.Struct}
 */


proto.manabie.bob.PromotionRule.prototype.getRewards = function () {
  return (
    /** @type{?proto.google.protobuf.Struct} */
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 5)
  );
};
/** @param {?proto.google.protobuf.Struct|undefined} value */


proto.manabie.bob.PromotionRule.prototype.setRewards = function (value) {
  jspb.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.PromotionRule.prototype.clearRewards = function () {
  this.setRewards(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.PromotionRule.prototype.hasRewards = function () {
  return jspb.Message.getField(this, 5) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CreatePromotionRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CreatePromotionRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CreatePromotionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CreatePromotionRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      promotion: (f = msg.getPromotion()) && proto.manabie.bob.Promotion.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CreatePromotionRequest}
 */


proto.manabie.bob.CreatePromotionRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CreatePromotionRequest();
  return proto.manabie.bob.CreatePromotionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CreatePromotionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CreatePromotionRequest}
 */


proto.manabie.bob.CreatePromotionRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Promotion();
        reader.readMessage(value, proto.manabie.bob.Promotion.deserializeBinaryFromReader);
        msg.setPromotion(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CreatePromotionRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CreatePromotionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CreatePromotionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CreatePromotionRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPromotion();

  if (f != null) {
    writer.writeMessage(1, f, proto.manabie.bob.Promotion.serializeBinaryToWriter);
  }
};
/**
 * optional Promotion promotion = 1;
 * @return {?proto.manabie.bob.Promotion}
 */


proto.manabie.bob.CreatePromotionRequest.prototype.getPromotion = function () {
  return (
    /** @type{?proto.manabie.bob.Promotion} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.Promotion, 1)
  );
};
/** @param {?proto.manabie.bob.Promotion|undefined} value */


proto.manabie.bob.CreatePromotionRequest.prototype.setPromotion = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.CreatePromotionRequest.prototype.clearPromotion = function () {
  this.setPromotion(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.CreatePromotionRequest.prototype.hasPromotion = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CreatePromotionResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CreatePromotionResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CreatePromotionResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CreatePromotionResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      promotionId: jspb.Message.getFieldWithDefault(msg, 1, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CreatePromotionResponse}
 */


proto.manabie.bob.CreatePromotionResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CreatePromotionResponse();
  return proto.manabie.bob.CreatePromotionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CreatePromotionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CreatePromotionResponse}
 */


proto.manabie.bob.CreatePromotionResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPromotionId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CreatePromotionResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CreatePromotionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CreatePromotionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CreatePromotionResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPromotionId();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }
};
/**
 * optional int32 promotion_id = 1;
 * @return {number}
 */


proto.manabie.bob.CreatePromotionResponse.prototype.getPromotionId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.CreatePromotionResponse.prototype.setPromotionId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdatePromotionRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdatePromotionRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdatePromotionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdatePromotionRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      promotionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      status: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdatePromotionRequest}
 */


proto.manabie.bob.UpdatePromotionRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdatePromotionRequest();
  return proto.manabie.bob.UpdatePromotionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdatePromotionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdatePromotionRequest}
 */


proto.manabie.bob.UpdatePromotionRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPromotionId(value);
        break;

      case 2:
        var value =
        /** @type {!proto.manabie.bob.PromoStatus} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdatePromotionRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdatePromotionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdatePromotionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdatePromotionRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPromotionId();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
};
/**
 * optional int32 promotion_id = 1;
 * @return {number}
 */


proto.manabie.bob.UpdatePromotionRequest.prototype.getPromotionId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.UpdatePromotionRequest.prototype.setPromotionId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional PromoStatus status = 2;
 * @return {!proto.manabie.bob.PromoStatus}
 */


proto.manabie.bob.UpdatePromotionRequest.prototype.getStatus = function () {
  return (
    /** @type {!proto.manabie.bob.PromoStatus} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {!proto.manabie.bob.PromoStatus} value */


proto.manabie.bob.UpdatePromotionRequest.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdatePromotionResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdatePromotionResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdatePromotionResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdatePromotionResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdatePromotionResponse}
 */


proto.manabie.bob.UpdatePromotionResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdatePromotionResponse();
  return proto.manabie.bob.UpdatePromotionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdatePromotionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdatePromotionResponse}
 */


proto.manabie.bob.UpdatePromotionResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdatePromotionResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdatePromotionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdatePromotionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdatePromotionResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.UpdatePromotionResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.UpdatePromotionResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UsePromotionCodeRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UsePromotionCodeRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UsePromotionCodeRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UsePromotionCodeRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      country: jspb.Message.getFieldWithDefault(msg, 1, 0),
      code: jspb.Message.getFieldWithDefault(msg, 2, ""),
      amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
      plan: jspb.Message.getFieldWithDefault(msg, 4, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UsePromotionCodeRequest}
 */


proto.manabie.bob.UsePromotionCodeRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UsePromotionCodeRequest();
  return proto.manabie.bob.UsePromotionCodeRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UsePromotionCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UsePromotionCodeRequest}
 */


proto.manabie.bob.UsePromotionCodeRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCode(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readDouble();
        msg.setAmount(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPlan(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UsePromotionCodeRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UsePromotionCodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UsePromotionCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UsePromotionCodeRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }

  f = message.getCode();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getAmount();

  if (f !== 0.0) {
    writer.writeDouble(3, f);
  }

  f = message.getPlan();

  if (f.length > 0) {
    writer.writeString(4, f);
  }
};
/**
 * optional Country country = 1;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.UsePromotionCodeRequest.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.UsePromotionCodeRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string code = 2;
 * @return {string}
 */


proto.manabie.bob.UsePromotionCodeRequest.prototype.getCode = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UsePromotionCodeRequest.prototype.setCode = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional double amount = 3;
 * @return {number}
 */


proto.manabie.bob.UsePromotionCodeRequest.prototype.getAmount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.UsePromotionCodeRequest.prototype.setAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};
/**
 * optional string plan = 4;
 * @return {string}
 */


proto.manabie.bob.UsePromotionCodeRequest.prototype.getPlan = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UsePromotionCodeRequest.prototype.setPlan = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UsePromotionCodeResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UsePromotionCodeResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UsePromotionCodeResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UsePromotionCodeResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
      promoDiscountAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
      expiredDate: (f = msg.getExpiredDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UsePromotionCodeResponse}
 */


proto.manabie.bob.UsePromotionCodeResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UsePromotionCodeResponse();
  return proto.manabie.bob.UsePromotionCodeResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UsePromotionCodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UsePromotionCodeResponse}
 */


proto.manabie.bob.UsePromotionCodeResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readDouble();
        msg.setAmount(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readDouble();
        msg.setPromoDiscountAmount(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setExpiredDate(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UsePromotionCodeResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UsePromotionCodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UsePromotionCodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UsePromotionCodeResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAmount();

  if (f !== 0.0) {
    writer.writeDouble(1, f);
  }

  f = message.getPromoDiscountAmount();

  if (f !== 0.0) {
    writer.writeDouble(2, f);
  }

  f = message.getExpiredDate();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional double amount = 1;
 * @return {number}
 */


proto.manabie.bob.UsePromotionCodeResponse.prototype.getAmount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.UsePromotionCodeResponse.prototype.setAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};
/**
 * optional double promo_discount_amount = 2;
 * @return {number}
 */


proto.manabie.bob.UsePromotionCodeResponse.prototype.getPromoDiscountAmount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.UsePromotionCodeResponse.prototype.setPromoDiscountAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};
/**
 * optional google.protobuf.Timestamp expired_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.UsePromotionCodeResponse.prototype.getExpiredDate = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.UsePromotionCodeResponse.prototype.setExpiredDate = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.UsePromotionCodeResponse.prototype.clearExpiredDate = function () {
  this.setExpiredDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.UsePromotionCodeResponse.prototype.hasExpiredDate = function () {
  return jspb.Message.getField(this, 3) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CheckPromotionCodeRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CheckPromotionCodeRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CheckPromotionCodeRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CheckPromotionCodeRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      country: jspb.Message.getFieldWithDefault(msg, 1, 0),
      code: jspb.Message.getFieldWithDefault(msg, 2, ""),
      packageId: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CheckPromotionCodeRequest}
 */


proto.manabie.bob.CheckPromotionCodeRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CheckPromotionCodeRequest();
  return proto.manabie.bob.CheckPromotionCodeRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CheckPromotionCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CheckPromotionCodeRequest}
 */


proto.manabie.bob.CheckPromotionCodeRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCode(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPackageId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CheckPromotionCodeRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CheckPromotionCodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CheckPromotionCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CheckPromotionCodeRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }

  f = message.getCode();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getPackageId();

  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};
/**
 * optional Country country = 1;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.CheckPromotionCodeRequest.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.CheckPromotionCodeRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string code = 2;
 * @return {string}
 */


proto.manabie.bob.CheckPromotionCodeRequest.prototype.getCode = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CheckPromotionCodeRequest.prototype.setCode = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 package_id = 3;
 * @return {number}
 */


proto.manabie.bob.CheckPromotionCodeRequest.prototype.getPackageId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.CheckPromotionCodeRequest.prototype.setPackageId = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CheckPromotionCodeResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CheckPromotionCodeResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CheckPromotionCodeResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CheckPromotionCodeResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
      promoDiscountAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
      expiredDate: (f = msg.getExpiredDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CheckPromotionCodeResponse}
 */


proto.manabie.bob.CheckPromotionCodeResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CheckPromotionCodeResponse();
  return proto.manabie.bob.CheckPromotionCodeResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CheckPromotionCodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CheckPromotionCodeResponse}
 */


proto.manabie.bob.CheckPromotionCodeResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readDouble();
        msg.setAmount(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readDouble();
        msg.setPromoDiscountAmount(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setExpiredDate(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CheckPromotionCodeResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CheckPromotionCodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CheckPromotionCodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CheckPromotionCodeResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAmount();

  if (f !== 0.0) {
    writer.writeDouble(1, f);
  }

  f = message.getPromoDiscountAmount();

  if (f !== 0.0) {
    writer.writeDouble(2, f);
  }

  f = message.getExpiredDate();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional double amount = 1;
 * @return {number}
 */


proto.manabie.bob.CheckPromotionCodeResponse.prototype.getAmount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.CheckPromotionCodeResponse.prototype.setAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};
/**
 * optional double promo_discount_amount = 2;
 * @return {number}
 */


proto.manabie.bob.CheckPromotionCodeResponse.prototype.getPromoDiscountAmount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.CheckPromotionCodeResponse.prototype.setPromoDiscountAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};
/**
 * optional google.protobuf.Timestamp expired_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.CheckPromotionCodeResponse.prototype.getExpiredDate = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.CheckPromotionCodeResponse.prototype.setExpiredDate = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.CheckPromotionCodeResponse.prototype.clearExpiredDate = function () {
  this.setExpiredDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.CheckPromotionCodeResponse.prototype.hasExpiredDate = function () {
  return jspb.Message.getField(this, 3) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CreateGHNOrderRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CreateGHNOrderRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CreateGHNOrderRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CreateGHNOrderRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      packageId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      studentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
      promotionCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
      customerName: jspb.Message.getFieldWithDefault(msg, 4, ""),
      customerPhoneNumber: jspb.Message.getFieldWithDefault(msg, 5, ""),
      ghnDistrictId: jspb.Message.getFieldWithDefault(msg, 6, 0),
      ghnWardCode: jspb.Message.getFieldWithDefault(msg, 7, ""),
      customerAddress: jspb.Message.getFieldWithDefault(msg, 8, ""),
      orderId: jspb.Message.getFieldWithDefault(msg, 9, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CreateGHNOrderRequest}
 */


proto.manabie.bob.CreateGHNOrderRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CreateGHNOrderRequest();
  return proto.manabie.bob.CreateGHNOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CreateGHNOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CreateGHNOrderRequest}
 */


proto.manabie.bob.CreateGHNOrderRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPackageId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPromotionCode(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCustomerName(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCustomerPhoneNumber(value);
        break;

      case 6:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setGhnDistrictId(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGhnWardCode(value);
        break;

      case 8:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCustomerAddress(value);
        break;

      case 9:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setOrderId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CreateGHNOrderRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CreateGHNOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CreateGHNOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CreateGHNOrderRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPackageId();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getPromotionCode();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getCustomerName();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getCustomerPhoneNumber();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getGhnDistrictId();

  if (f !== 0) {
    writer.writeInt32(6, f);
  }

  f = message.getGhnWardCode();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getCustomerAddress();

  if (f.length > 0) {
    writer.writeString(8, f);
  }

  f = message.getOrderId();

  if (f !== 0) {
    writer.writeInt32(9, f);
  }
};
/**
 * optional int32 package_id = 1;
 * @return {number}
 */


proto.manabie.bob.CreateGHNOrderRequest.prototype.getPackageId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.CreateGHNOrderRequest.prototype.setPackageId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string student_id = 2;
 * @return {string}
 */


proto.manabie.bob.CreateGHNOrderRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CreateGHNOrderRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string promotion_code = 3;
 * @return {string}
 */


proto.manabie.bob.CreateGHNOrderRequest.prototype.getPromotionCode = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CreateGHNOrderRequest.prototype.setPromotionCode = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string customer_name = 4;
 * @return {string}
 */


proto.manabie.bob.CreateGHNOrderRequest.prototype.getCustomerName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CreateGHNOrderRequest.prototype.setCustomerName = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string customer_phone_number = 5;
 * @return {string}
 */


proto.manabie.bob.CreateGHNOrderRequest.prototype.getCustomerPhoneNumber = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CreateGHNOrderRequest.prototype.setCustomerPhoneNumber = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int32 ghn_district_id = 6;
 * @return {number}
 */


proto.manabie.bob.CreateGHNOrderRequest.prototype.getGhnDistrictId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.CreateGHNOrderRequest.prototype.setGhnDistrictId = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional string ghn_ward_code = 7;
 * @return {string}
 */


proto.manabie.bob.CreateGHNOrderRequest.prototype.getGhnWardCode = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CreateGHNOrderRequest.prototype.setGhnWardCode = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string customer_address = 8;
 * @return {string}
 */


proto.manabie.bob.CreateGHNOrderRequest.prototype.getCustomerAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 8, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CreateGHNOrderRequest.prototype.setCustomerAddress = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};
/**
 * optional int32 order_id = 9;
 * @return {number}
 */


proto.manabie.bob.CreateGHNOrderRequest.prototype.getOrderId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 9, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.CreateGHNOrderRequest.prototype.setOrderId = function (value) {
  jspb.Message.setProto3IntField(this, 9, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CreateGHNOrderResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CreateGHNOrderResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CreateGHNOrderResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CreateGHNOrderResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      orderId: jspb.Message.getFieldWithDefault(msg, 1, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CreateGHNOrderResponse}
 */


proto.manabie.bob.CreateGHNOrderResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CreateGHNOrderResponse();
  return proto.manabie.bob.CreateGHNOrderResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CreateGHNOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CreateGHNOrderResponse}
 */


proto.manabie.bob.CreateGHNOrderResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setOrderId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CreateGHNOrderResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CreateGHNOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CreateGHNOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CreateGHNOrderResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrderId();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }
};
/**
 * optional int32 order_id = 1;
 * @return {number}
 */


proto.manabie.bob.CreateGHNOrderResponse.prototype.getOrderId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.CreateGHNOrderResponse.prototype.setOrderId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateGHNOrderRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateGHNOrderRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateGHNOrderRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateGHNOrderRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      ghnOrderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      action: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateGHNOrderRequest}
 */


proto.manabie.bob.UpdateGHNOrderRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateGHNOrderRequest();
  return proto.manabie.bob.UpdateGHNOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateGHNOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateGHNOrderRequest}
 */


proto.manabie.bob.UpdateGHNOrderRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGhnOrderId(value);
        break;

      case 2:
        var value =
        /** @type {!proto.manabie.bob.CodOrderTransitionAction} */
        reader.readEnum();
        msg.setAction(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateGHNOrderRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateGHNOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateGHNOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateGHNOrderRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getGhnOrderId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getAction();

  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
};
/**
 * optional string ghn_order_id = 1;
 * @return {string}
 */


proto.manabie.bob.UpdateGHNOrderRequest.prototype.getGhnOrderId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UpdateGHNOrderRequest.prototype.setGhnOrderId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional CodOrderTransitionAction action = 2;
 * @return {!proto.manabie.bob.CodOrderTransitionAction}
 */


proto.manabie.bob.UpdateGHNOrderRequest.prototype.getAction = function () {
  return (
    /** @type {!proto.manabie.bob.CodOrderTransitionAction} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {!proto.manabie.bob.CodOrderTransitionAction} value */


proto.manabie.bob.UpdateGHNOrderRequest.prototype.setAction = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateGHNOrderResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateGHNOrderResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateGHNOrderResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateGHNOrderResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateGHNOrderResponse}
 */


proto.manabie.bob.UpdateGHNOrderResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateGHNOrderResponse();
  return proto.manabie.bob.UpdateGHNOrderResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateGHNOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateGHNOrderResponse}
 */


proto.manabie.bob.UpdateGHNOrderResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateGHNOrderResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateGHNOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateGHNOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateGHNOrderResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdatePaymentMethodRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdatePaymentMethodRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdatePaymentMethodRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdatePaymentMethodRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      orderId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      paymentMethod: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdatePaymentMethodRequest}
 */


proto.manabie.bob.UpdatePaymentMethodRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdatePaymentMethodRequest();
  return proto.manabie.bob.UpdatePaymentMethodRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdatePaymentMethodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdatePaymentMethodRequest}
 */


proto.manabie.bob.UpdatePaymentMethodRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setOrderId(value);
        break;

      case 2:
        var value =
        /** @type {!proto.manabie.bob.PaymentMethod} */
        reader.readEnum();
        msg.setPaymentMethod(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdatePaymentMethodRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdatePaymentMethodRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdatePaymentMethodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdatePaymentMethodRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrderId();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getPaymentMethod();

  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
};
/**
 * optional int32 order_id = 1;
 * @return {number}
 */


proto.manabie.bob.UpdatePaymentMethodRequest.prototype.getOrderId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.UpdatePaymentMethodRequest.prototype.setOrderId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional PaymentMethod payment_method = 2;
 * @return {!proto.manabie.bob.PaymentMethod}
 */


proto.manabie.bob.UpdatePaymentMethodRequest.prototype.getPaymentMethod = function () {
  return (
    /** @type {!proto.manabie.bob.PaymentMethod} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {!proto.manabie.bob.PaymentMethod} value */


proto.manabie.bob.UpdatePaymentMethodRequest.prototype.setPaymentMethod = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdatePaymentMethodResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdatePaymentMethodResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdatePaymentMethodResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdatePaymentMethodResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      paymentUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdatePaymentMethodResponse}
 */


proto.manabie.bob.UpdatePaymentMethodResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdatePaymentMethodResponse();
  return proto.manabie.bob.UpdatePaymentMethodResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdatePaymentMethodResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdatePaymentMethodResponse}
 */


proto.manabie.bob.UpdatePaymentMethodResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPaymentUrl(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdatePaymentMethodResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdatePaymentMethodResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdatePaymentMethodResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdatePaymentMethodResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPaymentUrl();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string payment_url = 1;
 * @return {string}
 */


proto.manabie.bob.UpdatePaymentMethodResponse.prototype.getPaymentUrl = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UpdatePaymentMethodResponse.prototype.setPaymentUrl = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveCurrentSubscriptionRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveCurrentSubscriptionRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveCurrentSubscriptionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveCurrentSubscriptionRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveCurrentSubscriptionRequest}
 */


proto.manabie.bob.RetrieveCurrentSubscriptionRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveCurrentSubscriptionRequest();
  return proto.manabie.bob.RetrieveCurrentSubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveCurrentSubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveCurrentSubscriptionRequest}
 */


proto.manabie.bob.RetrieveCurrentSubscriptionRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveCurrentSubscriptionRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveCurrentSubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveCurrentSubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveCurrentSubscriptionRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveCurrentSubscriptionRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveCurrentSubscriptionRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveCurrentSubscriptionResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveCurrentSubscriptionResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveCurrentSubscriptionResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveCurrentSubscriptionResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveCurrentSubscriptionResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      subscriptionsList: jspb.Message.toObjectList(msg.getSubscriptionsList(), proto.manabie.bob.StudentSubscription.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveCurrentSubscriptionResponse}
 */


proto.manabie.bob.RetrieveCurrentSubscriptionResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveCurrentSubscriptionResponse();
  return proto.manabie.bob.RetrieveCurrentSubscriptionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveCurrentSubscriptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveCurrentSubscriptionResponse}
 */


proto.manabie.bob.RetrieveCurrentSubscriptionResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.StudentSubscription();
        reader.readMessage(value, proto.manabie.bob.StudentSubscription.deserializeBinaryFromReader);
        msg.addSubscriptions(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveCurrentSubscriptionResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveCurrentSubscriptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveCurrentSubscriptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveCurrentSubscriptionResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSubscriptionsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.StudentSubscription.serializeBinaryToWriter);
  }
};
/**
 * repeated StudentSubscription subscriptions = 1;
 * @return {!Array<!proto.manabie.bob.StudentSubscription>}
 */


proto.manabie.bob.RetrieveCurrentSubscriptionResponse.prototype.getSubscriptionsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.StudentSubscription>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.StudentSubscription, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.StudentSubscription>} value */


proto.manabie.bob.RetrieveCurrentSubscriptionResponse.prototype.setSubscriptionsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.StudentSubscription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.StudentSubscription}
 */


proto.manabie.bob.RetrieveCurrentSubscriptionResponse.prototype.addSubscriptions = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.StudentSubscription, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveCurrentSubscriptionResponse.prototype.clearSubscriptionsList = function () {
  this.setSubscriptionsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.MarkOrderProcessingRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.MarkOrderProcessingRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.MarkOrderProcessingRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.MarkOrderProcessingRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      orderId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      ref: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.MarkOrderProcessingRequest}
 */


proto.manabie.bob.MarkOrderProcessingRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.MarkOrderProcessingRequest();
  return proto.manabie.bob.MarkOrderProcessingRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.MarkOrderProcessingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.MarkOrderProcessingRequest}
 */


proto.manabie.bob.MarkOrderProcessingRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setOrderId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setRef(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.MarkOrderProcessingRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.MarkOrderProcessingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.MarkOrderProcessingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.MarkOrderProcessingRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrderId();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getRef();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional int32 order_id = 1;
 * @return {number}
 */


proto.manabie.bob.MarkOrderProcessingRequest.prototype.getOrderId = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.MarkOrderProcessingRequest.prototype.setOrderId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string ref = 2;
 * @return {string}
 */


proto.manabie.bob.MarkOrderProcessingRequest.prototype.getRef = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.MarkOrderProcessingRequest.prototype.setRef = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.MarkOrderProcessingResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.MarkOrderProcessingResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.MarkOrderProcessingResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.MarkOrderProcessingResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.MarkOrderProcessingResponse}
 */


proto.manabie.bob.MarkOrderProcessingResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.MarkOrderProcessingResponse();
  return proto.manabie.bob.MarkOrderProcessingResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.MarkOrderProcessingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.MarkOrderProcessingResponse}
 */


proto.manabie.bob.MarkOrderProcessingResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.MarkOrderProcessingResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.MarkOrderProcessingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.MarkOrderProcessingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.MarkOrderProcessingResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.VerifyIosReceiptRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.VerifyIosReceiptRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.VerifyIosReceiptRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.VerifyIosReceiptRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      reciept: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.VerifyIosReceiptRequest}
 */


proto.manabie.bob.VerifyIosReceiptRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.VerifyIosReceiptRequest();
  return proto.manabie.bob.VerifyIosReceiptRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.VerifyIosReceiptRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.VerifyIosReceiptRequest}
 */


proto.manabie.bob.VerifyIosReceiptRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setReciept(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.VerifyIosReceiptRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.VerifyIosReceiptRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.VerifyIosReceiptRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.VerifyIosReceiptRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getReciept();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string reciept = 1;
 * @return {string}
 */


proto.manabie.bob.VerifyIosReceiptRequest.prototype.getReciept = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.VerifyIosReceiptRequest.prototype.setReciept = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.VerifyIosReceiptResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.VerifyIosReceiptResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.VerifyIosReceiptResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.VerifyIosReceiptResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.VerifyIosReceiptResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      refsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.VerifyIosReceiptResponse}
 */


proto.manabie.bob.VerifyIosReceiptResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.VerifyIosReceiptResponse();
  return proto.manabie.bob.VerifyIosReceiptResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.VerifyIosReceiptResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.VerifyIosReceiptResponse}
 */


proto.manabie.bob.VerifyIosReceiptResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addRefs(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.VerifyIosReceiptResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.VerifyIosReceiptResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.VerifyIosReceiptResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.VerifyIosReceiptResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getRefsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string refs = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.VerifyIosReceiptResponse.prototype.getRefsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.VerifyIosReceiptResponse.prototype.setRefsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.VerifyIosReceiptResponse.prototype.addRefs = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.VerifyIosReceiptResponse.prototype.clearRefsList = function () {
  this.setRefsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest}
 */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest();
  return proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest}
 */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      promotionCode: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse}
 */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse();
  return proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse}
 */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPromotionCode(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPromotionCode();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string promotion_code = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.prototype.getPromotionCode = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.prototype.setPromotionCode = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * @enum {number}
 */


proto.manabie.bob.PromoType = {
  PROMOTION: 0,
  PROMOTION_TEACHER: 1,
  PROMOTION_REFERRAL: 2,
  PROMOTION_LD: 3,
  PROMOTION_SC: 4,
  PROMOTION_KOL: 5,
  PROMOTION_ACTIVATION: 6
};
/**
 * @enum {number}
 */

proto.manabie.bob.PromoDiscountType = {
  PROMOTION_DISCOUNT_TYPE_FIXED_AMOUNT: 0,
  PROMOTION_DISCOUNT_TYPE_PERCENTAGE: 1
};
/**
 * @enum {number}
 */

proto.manabie.bob.PromoStatus = {
  PROMOTION_STATUS_PUBLISHED: 0,
  PROMOTION_STATUS_ARCHIVED: 1
};
goog.object.extend(exports, proto.manabie.bob);